import React, { useContext } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Filler,
  Tooltip,
} from "chart.js/auto";
import { Line } from "react-chartjs-2";
import { authContext } from "../context/authContext";

ChartJS.register(
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Filler,
  Tooltip
);

const CHART_ACCENT = "#00d492";
const CHART_MUTED = "#243044";
const CHART_TEXT = "#8b9cb3";

const formatChartTime = (timestamp) => {
  const date = new Date(timestamp * 1000);
  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

const Chart = () => {
  const { transactions } = useContext(authContext);

  const recentTransactions = [...(transactions || [])].slice(0, 20).reverse();

  const data = {
    labels: recentTransactions.map((item) => formatChartTime(item.created)),
    datasets: [
      {
        label: "Transaction Amount",
        data: recentTransactions.map((item) => item.amount / 100),
        fill: true,
        backgroundColor: "rgba(0, 212, 146, 0.08)",
        borderColor: CHART_ACCENT,
        borderWidth: 2,
        pointBackgroundColor: CHART_ACCENT,
        pointBorderColor: "#0a0e14",
        pointBorderWidth: 2,
        pointRadius: 4,
        pointHoverRadius: 6,
        tension: 0.35,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#161d27",
        titleColor: "#eef2f7",
        bodyColor: "#8b9cb3",
        borderColor: "#243044",
        borderWidth: 1,
        padding: 12,
        displayColors: false,
      },
    },
    scales: {
      x: {
        grid: { color: CHART_MUTED, drawBorder: false },
        ticks: { color: CHART_TEXT, font: { size: 11 } },
      },
      y: {
        beginAtZero: true,
        grid: { color: CHART_MUTED, drawBorder: false },
        ticks: { color: CHART_TEXT, font: { size: 11 } },
      },
    },
  };

  return (
    <div className="chartWrapeprDiv">
      <Line data={data} options={options} />
    </div>
  );
};

export default Chart;
